import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import API from "@/axios";
import { PersonalPayload, SettingsState } from "../types";

const actions: ActionTree<SettingsState, RootState> = {
  postPersonalInformation({ dispatch }, payload: PersonalPayload) {
    return API.post("/account", payload).then(async (res) => {
      const user = res.data.data;
      await dispatch("auth/setUser", user, { root: true });
    });
  },
};

export default actions;
